// extracted by mini-css-extract-plugin
export default {"searchBox":"AdminTable_searchBox__G28Gj","content":"AdminTable_content__V3t-a","phone":"AdminTable_phone__hkXRo"};